import React, { Component } from 'react';
import Header from "../layout/header"
import Footer from "../layout/footer"
import checkmarkImg from "../images/checkmark.b8187469.svg"
import linkedinImg from "../images/linkedin.svg"
import uploadFolderImg from "../images/upload-folder.svg"
import anoopImg from "../images/anoop.jpeg"
import { Link } from "react-router-dom";
import $ from 'jquery';
import { database,secUser } from '../firebase'
import { storage } from "../firebase";
import moment from 'moment';
export default class UserProfile extends Component {
  constructor(props) {
    super(props)
    this.state = {
      userData: [],
      testimonialUrl: null,
      url: "",
      resumeImage: null,
      resumeFile: "",
      resumeLink:"",
      emailId:"",
      phoneno:"",
      fileName:false,
      image:null
      
    }
    this.handleChange = this.handleChange.bind(this);
    this.handleImageChange = this.handleImageChange.bind(this);
    this.validateSubmission = this.validateSubmission.bind(this);
    this.updateValidateSubmission = this.updateValidateSubmission.bind(this);
    this.handleResumeFile = this.handleResumeFile.bind(this)
    this.logout = this.logout.bind(this);

  }
  logout(){
    localStorage.removeItem("userId");
    localStorage.removeItem("userName");
    localStorage.removeItem("userImage")
    localStorage.removeItem("guidanceArray");
    window.location.href="/"
  }
  updateValidateSubmission = () => {
    let newDate = moment(new Date()).format("DD/MM/YYYY")
    const userDataNew = {
      userId: this.state.secUserId,
      fullName: this.state.fullName,
      emailId: this.state.emailId,
      phoneno: this.state.phoneno,
      imageUrl: this.state.url ? this.state.url : this.state.testimonialUrl,
      role: "User"
    }
      database.ref(`SecUser/${this.state.secUserId}`).update(userDataNew).then(() => {
        alert("Updated Successfully")
        
        localStorage.setItem("userId",this.state.secUserId)
        localStorage.setItem("userName",this.state.fullName)
        localStorage.setItem("userImage",this.state.url ? this.state.url : this.state.testimonialUrl)
        window.location.href = "/user-dashboard"
    }).catch(() => {
      alert("Somthing went wrong")
    })

  }
  componentDidMount() {
    let userKey = localStorage.getItem("guidanceId");
    let secUserId = localStorage.getItem("userId");
    console.log("userKey....",userKey)
    console.log("secUserId....",secUserId)
    this.setState({
      userKey: userKey,
      secUserId:secUserId
    })
    this.renderList(secUserId)
  }
  async renderList(keyId) {
    let dataList = []
    let id = keyId;
    const ref = id ? '/SecUser/' + id : 'SecUser'
    const userRef = database.ref(ref)
    const valueRef = id ? userRef : await userRef.orderByChild('key').equalTo('value')
    const snapshot = await valueRef.once('value')
    const val = snapshot.val()
    if (val) {
      
      let data = val;
      localStorage.setItem("userName", val.fullName)
      $("#fullName").val(val.fullName)
      $("#emailId").val(val.emailId)
      $("#phoneno").val(val.phoneno)
      $("#password").val(val.password)
      $("#imageUrl")
                  .attr('src', val.imageUrl);
    
      this.setState({
        userData: val,
        fullName: val.fullName,
        emailId: data.emailId,
        phoneno: val.phoneno,
        testimonialUrl:val.imageUrl?val.imageUrl:null,
        imageUrl:val.imageUrl?val.imageUrl:null,
      })
    }

  }
  handleImageChange = e => {
      this.setState({
image:URL.createObjectURL(e.target.files[0]),
        imageUrl:e.target.files[0],
        fileName: true
      })
    
  };
  handleResumeFile = e => {
    if (e.target.files[0]) {
      this.setState({
        resumeImage: e.target.files[0],
        resumeFileName: true
      })
    }
  }
  validateSubmission = () => {
    const regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if (this.state.fullName === '') {
      alert('Name Required')
    }
    else if (this.state.emailId === '') {
      alert('Email Id Required')
    }
  
    else if (this.state.emailId !== '' && regex.test(this.state.emailId) === false) {
      alert('Email Id is not valid')
    }
    else if (this.state.phoneno === '') {
      alert('Phone Required')
    }
    // else if (this.state.password === '') {
    //   alert('Password Required')
    // }
    // else if (this.state.authorized_usa === '') {
    //   alert('Are you located in the UAE Required')
    // }
    // else if (this.state.goals === '') {
    //   alert('Goals Required')
    // }
    else {
      console.log("this.state.fullName...",this.state.fullName)
      console.log("this.state.resumeFileName...",this.state.resumeFileName)
      if (this.state.fileName) {
        const uploadTask = storage.ref(`SecUser/${this.state.imageUrl.name}`).put(this.state.imageUrl);
        uploadTask.on(
          "state_changed",
          snapshot => {
            const progress = Math.round(
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100
            );
            this.setState({
              progress: progress
            })
          },
          error => {
            console.log(error);
          },
          () => {
            storage
              .ref("SecUser")
              .child(this.state.imageUrl.name)
              .getDownloadURL()
              .then(url => {
                console.log("url...", url)
                $("#imageUrl")
                  .attr('src', url);
                this.setState({
                  url: url
                })
                this.updateValidateSubmission("");
              });

          }
        );
      }
      // if (this.state.resumeFileName) {
      //   const uploadTask = storage.ref(`Guidance/${this.state.resumeImage.name}`).put(this.state.resumeImage);
      //   uploadTask.on(
      //     "state_changed",
      //     snapshot => {
      //       const progress = Math.round(
      //         (snapshot.bytesTransferred / snapshot.totalBytes) * 100
      //       );
      //       this.setState({
      //         progress: progress
      //       })
      //     },
      //     error => {
      //       console.log(error);
      //     },
      //     () => {
      //       storage
      //         .ref("Guidance")
      //         .child(this.state.resumeImage.name)
      //         .getDownloadURL()
      //         .then(url => {
      //           console.log("url...", url)
      //           $("#resumeFile")
      //             .attr('src', url);
      //           this.setState({
      //             resumeFile: url
      //           })
      //           this.updateValidateSubmission()
      //         });

      //     }

      //   );
      // }
      else {

        this.updateValidateSubmission("");

      }
    }
  }
  handleChange = (event) => {
    const { value, name } = event.target;
    console.log("name..",event.target.name)
    this.setState({
      [name]: value,
    });
  };
  render() {
    return (
      <div className="main-wrapper assesment-wrapper">
        <Header></Header>
        <div className="main-content p-0" style={{ background: "#f4f6f9" }}>
          <div className="container p-0 pt-5">
            <div className='row'>
              <div className='col-md-4 col-lg-3 mt-4'>
                <div className="usr-dasbrd-menu">
                  <div className='usr-dasbrd-menuhead'>My Account</div>
                  <Link className="usr-dasbrd-menuList" to="/user-dashboard">
                    Dashoboard
                  </Link>
                  <Link className="usr-dasbrd-menuList usr-dasbrd-menuAct" to="/user-profile">
                    Profile
                  </Link>
                  <Link className="usr-dasbrd-menuList" to="" onClick={this.logout}>
                    LogOut
                  </Link>
                </div>
              </div>
              <div className='col-lg-6 m-auto p-0'>

                <form className='form-main-wrapper'>
                  <div className="form-group">
                    <label for="exampleFormControlInput1">Name <span style={{ color: "#535fe5" }}>*</span></label>
                    <input type="text" name="fullName" id="fullName" className="form-control" onChange={this.handleChange} />
                  </div>
                  <div className="form-group">
                    <label for="exampleFormControlInput1">Email <span style={{ color: "#535fe5" }}>*</span></label>
                    <input type="email" name="emailId" id="emailId" className="form-control" onChange={this.handleChange} />
                  </div>
                  <div className="form-group">
                    <label for="exampleFormControlInput1"> Phone <span style={{ color: "#535fe5" }}>*</span></label>
                    <input type="text" name="phoneno" id="phoneno" className="form-control" onChange={this.handleChange} />
                  </div>
                  {/* <div className="form-group">
                    <label for="exampleFormControlInput1"> Password <span style={{ color: "#535fe5" }}>*</span></label>
                    <input type="password" name="password" id="password" className="form-control" onChange={this.handleChange} />
                  </div>
                  <div className="form-group">
                    <label for="exampleFormControlInput1">Are you located in the UAE?
                      <span style={{ color: "#535fe5" }}>*</span></label>
                    <div className='row'>
                      <label for="authorized_usa" className="label-radio" style={{ width: "100px" }}>
                        <input name="authorized_usa" id="authorized_usa" type="radio" value="Yes" checked={this.state.authorized_usa === 'Yes'} onChange={this.handleChange} />
                        <img className="label-radio-img" alt="Yes" src={checkmarkImg} />
                        <span>Yes</span>
                        <div className="label-radio-checkedBackground"></div>
                      </label>
                      <label for="authorized_usa" className="label-radio" style={{ width: "100px" }}>
                        <input name="authorized_usa" id="authorized_usa" type="radio" value="No" checked={this.state.authorized_usa === 'No'}onChange={this.handleChange} />
                        <img className="label-radio-img" alt="Yes" src={checkmarkImg} />
                        <span>No</span>
                        <div className="label-radio-checkedBackground"></div>
                      </label>
                    </div>
                  </div> */}
                  <div className="form-group">
                    <label for="fellow_cv" className="form-fileUpload">
                      <input id="imageUrl" name="imageUrl" type="file" onChange={this.handleImageChange} />
                      <div className="FormFileUpload_uploadContent__1quqH">
                    {this.state.fileName == true ? 
                      <img style={{width: '100px',
                      height: '100px'}} alt="" src={this.state.image} />
                    :
                        <img style={{width: '100px',
    height: '100px'}} alt="" src={this.state.imageUrl} />
                    }
                        <span className="form-fileUpload-title"> Upload Image</span>
                      </div>
                    </label>
                  </div>
                  {/* <div className="form-group">
                    <img src={anoopImg} className="prof-img" width="100" style={{borderRadius:"50%"}}></img>
                  </div>
                  <div className="form-group">
                    <p>To move forward with our course recommendation process, we ask that you share either your resume or a LinkedIn profile.  <span className='text-danger'>*</span></p>
                  </div>
                  <div className="form-group">
                    <label for="fellow_cv" className="form-fileUpload">
                      <input id="resumeFile" name="resumeFile" type="file" onChange={this.handleResumeFile} />
                      <div className="FormFileUpload_uploadContent__1quqH">
                        <img alt="Resume Upload" src={uploadFolderImg} />
                        <span className="form-fileUpload-title">Resume Upload</span>
                        <span className="form-fileUpload-helpText">.pdf, .doc, or .docx</span>
                      </div>
                    </label>
                  </div>
                  <div className="form-group">
                    <div className="input-group">
                      <input type="text" disabled className="form-control" id="resumeFile" />
                    </div>
                  </div>
                  <div className="form-group text-center">
                    <label>OR</label>
                  </div>
                  <div className="form-group">
                    <div className="input-group">
                      <span className="input-group-text">
                        <img src={linkedinImg}></img>
                      </span>
                      <input type="text" id="resumeLink" name="resumeLink" className="form-control" onChange={this.handleChange} placeholder="https://linkedin.com/in/profile" />
                    </div>
                  </div> */}

                  <div className="form-group mt-4">
                    <button type="button" className="btn btn-secondary w-100" onClick={this.validateSubmission} >Submit</button>
                    {/* <a href="/assesment/apply-1" className="btn btn-secondary w-100">
                        Submit
                      </a> */}
                  </div>
                </form>
              </div>
            </div>
          </div>

        </div>

      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ivano/userProfile.jsx